/* audit */
import { cfg } from '../../../config';
import { http } from '../http';
import { type ApiRsp } from '../types';

interface AuditService {
    getAuditLog(params: ReqAuditLog): Promise<ApiRsp>;
}

export const audit: AuditService = {
    getAuditLog: (params: ReqAuditLog) => {
        const query = http.buildUriQuery(params);
        const url = cfg.hub.API + `/logs?${query}`;
        return http.get(url);
    }
};

export type ReqAuditLog = {
    start_date: string;
    end_date?: string;
    client_id?: string;
    path?: string;
    limit?: number;
    offset?: number;
};
export type AuditLog = {
    id: number;
    created_at: string;
    user_id?: number;
    client_id?: string;
    remote_ip: string;
    status: number;
    method: string;
    path: string;
    latency: number;
    user_agent?: string;
    profile?: {
        name: string;
        utyp: string;
        unit: string;
    };
};